module.exports = __webpack_public_path__ + "media/illustrations/app-celular-ea170e29.svg";